import { render, staticRenderFns } from "./department_message.vue?vue&type=template&id=5d0ab540&"
import script from "./department_message.vue?vue&type=script&lang=js&"
export * from "./department_message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports